const passwordGenerator = () => {
    return Math.random().toString(36).slice(-10);
}

export default passwordGenerator;